import { getEnv } from "../../config/Config";
import { eaFetch } from "../common/ApiUtils";

/**
 * Get all available reports for an account
 * GET /api/v1/365/reports/accounts/{accountId}/reports/available
 */
export async function getAvailableReports(accountId, dispatch) {
  const response = await eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/reports/accounts/${accountId}/reports/available`
  );
  const reports = Array.isArray(response) ? response : (response?.content || []);
  dispatch({ type: "SET_AVAILABLE_REPORTS", payload: reports });
  return reports;
}

/**
 * Get all reports for an account (for role management)
 * GET /api/v1/365/reports/accounts/{accountId}/reports/all
 */
export async function getAllReports(accountId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/reports/accounts/${accountId}/reports/all`
  );
}

/**
 * Generate a report asynchronously
 * POST /api/v1/365/reports/accounts/{accountId}/{reportId}/generate?exportFormat=xlsx
 */
export async function generateReport(reportId, accountId, exportFormat, parameters, dispatch) {
  const body = parameters || {};
  const format = exportFormat || "xlsx";

  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "POST",
    `365/reports/accounts/${accountId}/${reportId}/generate?exportFormat=${format}`,
    body
  );
}

/**
 * Get all jobs for current user
 * GET /api/v1/365/reports/jobs?accountId=767733&status=COMPLETED&page=0&size=20
 */
export async function getMyJobs(accountId, status, page = 0, size = 20, dispatch) {
  let url = `365/reports/jobs?page=${page}&size=${size}&sort=createdAt,desc`;
  if (accountId) {
    url += `&accountId=${accountId}`;
  }
  if (status) {
    url += `&status=${status}`;
  }

  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    url
  );
}

/**
 * Get job details by ID
 * GET /api/v1/365/reports/jobs/{jobId}
 */
export async function getJobById(jobId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/reports/jobs/${jobId}`
  );
}

/**
 * Get active (pending) jobs for an account
 * GET /api/v1/365/reports/jobs/active?accountId={accountId}
 */
export async function getActiveJobs(accountId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/reports/jobs/active?accountId=${accountId}`
  );
}

/**
 * Get recent jobs (created in the last 5 minutes) for an account
 * GET /api/v1/365/reports/jobs/recent?accountId={accountId}
 */
export async function getRecentJobs(accountId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/reports/jobs/recent?accountId=${accountId}`
  );
}

/**
 * Get download URL for a completed report
 * GET /api/v1/365/reports/jobs/{jobId}/download
 */
export async function getDownloadUrl(jobId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    `365/reports/jobs/${jobId}/download`
  );
}

/**
 * Delete a job and its associated file
 * DELETE /api/v1/365/reports/jobs/{jobId}
 */
export async function deleteJob(jobId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "DELETE",
    `365/reports/jobs/${jobId}`
  );
}
